import Switch from "react-switch";
import { RemovingThrobber } from "../../../removing_throbber";
import {
	UserPreferenceModifiableSettings,
	useUserPreferencesMutation,
} from "../user_preferences_modal";
import { SettingsBaseItem } from "../../settings_items/settings_base_item";

export function UserPreferencesBooleanItem(props: {
	setting_key: UserPreferenceModifiableSettings;
	label: string;
	description: string;
	value: boolean;
}) {
	const mutation = useUserPreferencesMutation(props.setting_key);

	return (
		<SettingsBaseItem {...props}>
			<div className="flex w-fit gap-2">
				{mutation.isLoading && <RemovingThrobber />}
				<Switch
					height={24}
					disabled={mutation.isLoading}
					checked={props.value}
					onChange={(checked) =>
						mutation.mutate({
							[props.setting_key]: checked,
						})
					}
					onColor="#00c3cc"
					onHandleColor="#00f4ff"
					checkedIcon={
						<span className="flex h-full flex-col items-center justify-center text-black opacity-50">
							<i className="fas fa-check"></i>
						</span>
					}
					uncheckedIcon={
						<span className="flex h-full flex-col items-center justify-center text-black opacity-50">
							<i className="fas fa-times"></i>
						</span>
					}
				/>
			</div>
		</SettingsBaseItem>
	);
}
